{
    "columns": [
      {
        "header_id": "ngAppConfigId",
        "header_label": "ID",
        "jsonpath": "ngAppConfigId",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "category",
        "header_label": "Category",
        "jsonpath": "category",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "module",
        "header_label": "Module",
        "jsonpath": "module",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "orgType",
        "header_label": "Org Type",
        "jsonpath": "orgType",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "orgName",
        "header_label": "Org Name",
        "jsonpath": "orgName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "configKey",
        "header_label": "Key",
        "jsonpath": "configKey",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "configValue",
        "header_label": "Value",
        "jsonpath": "configValue",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "configDesc",
        "header_label": "Description",
        "jsonpath": "configDesc",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "createddate",
        "header_label": "Created Date",
        "jsonpath": "createddate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "isActive",
        "header_label": "Active",
        "jsonpath": "isActive",
        "isDisplayedAtHeader": "n",
        "isSearchable": "n"
      }
    ],
    "buttons": [],
    "apiDetails": "config.json",
    "pageName": "configListView",
    "orderByColumn": ["createddate"],
    "orderBy": ["desc"]
  }
  